<template>
  <div v-clickoutside="$_onOutsideClick" :class="classes" @mouseenter="$_onTriggerMouseenter" @mouseleave="$_onTriggerMouseleave">
    <div ref="reference" :class="[prefixCls + '-rel']" @click="$_onButtonClick" @mousedown="onFocus(false)" @mouseup="onBlur(false)">
      <slot></slot>
    </div>
    <transition name="fade">
      <div v-show="visible" ref="popper" :class="['popover']" :style="styles" @click.stop="$_stopClick">
        <div :class="[prefixCls + '-arrow']"></div>
        <div :class="[prefixCls + '-content']">
          <h3 v-if="confirm&&title" :class="[prefixCls + '-title']" v-html="title"></h3>
          <div v-if="confirm" :class="[prefixCls + '-inner']">
            <div :class="[prefixCls + '-footer','text-right']">
              <t-button size="sm" @click.native="cancel">{{ localeCancelText }}</t-button>
              <t-button type="primary" size="sm" @click.native="ok">{{ localeOkText }}</t-button>
            </div>
          </div>
          <div v-if="!confirm" :class="[prefixCls + '-inner']">
            <div v-if="showTitle" ref="title" :class="[prefixCls + '-title']">
              <slot name="title">
                <div :class="[prefixCls + '-title-inner']">{{ title }}</div>
              </slot>
            </div>
            <div :class="[prefixCls + '-body']">
              <div :class="[prefixCls + '-body-content']">
                <slot name="content">
                  <div :class="[prefixCls + '-body-content-inner']">{{ content }}</div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Popper from '../base/popper'
import TButton from '../button/button.vue'
import clickoutside from '../../directives/clickoutside'
import Locale from '../../mixins/locale'

const prefixCls = 'popover'

export default {
  name: 'TPoptip',
  components: { TButton },
  directives: { clickoutside },
  mixins: [Popper, Locale],
  props: {
    trigger: {
      type: String,
      default: 'click',
      validator(value) {
        return ['click', 'focus', 'hover'].includes(value)
      }
    },
    placement: {
      type: String,
      default: 'top',
      validator(value) {
        return [
          'top',
          'top-start',
          'top-end',
          'bottom',
          'bottom-start',
          'bottom-end',
          'left',
          'left-start',
          'left-end',
          'right',
          'right-start',
          'right-end'
        ].includes(value)
      }
    },
    title: {
      type: [String, Number]
    },
    content: {
      type: [String, Number]
    },
    width: {
      type: [String, Number]
    },
    confirm: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      showTitle: true,
      isInput: false
    }
  },
  computed: {
    classes() {
      return [
        `${prefixCls}-wrap`,
        {
          [`${prefixCls}-confirm`]: this.confirm
        }
      ]
    },
    styles() {
      let style = {}

      if (this.width) {
        style.width = `${this.width}px`
      }
      return style
    },
    localeOkText() {
      if (this.okText === undefined) {
        return this.t('t.poptip.okText')
      } else {
        return this.okText
      }
    },
    localeCancelText() {
      if (this.cancelText === undefined) {
        return this.t('t.poptip.cancelText')
      } else {
        return this.cancelText
      }
    }
  },
  mounted() {
    if (!this.confirm) {
      this.showTitle = this.$slots.title !== undefined
    }
    // if trigger and children is input or textarea,listen focus & blur event
    if (this.trigger === 'focus') {
      const $children = this.$_getInputChildren()
      if ($children) {
        $children.addEventListener('focus', this.onFocus, false)
        $children.addEventListener('blur', this.onBlur, false)
        this.isInput = true
      }
    }
  },
  beforeDestroy() {
    const $children = this.$_getInputChildren()
    if ($children) {
      $children.removeEventListener('focus', this.onFocus, false)
      $children.removeEventListener('blur', this.onBlur, false)
    }
  },
  methods: {
    // 添加私有方法
    $_onButtonClick() {
      if (this.confirm) {
        this.visible = !this.visible
        return true
      }
      if (this.trigger !== 'click') {
        return false
      }
      this.visible = !this.visible
    },
    $_onOutsideClick(e) {
      if (this.confirm) {
        this.visible = false
        return true
      }
      if (this.trigger !== 'click') {
        return false
      }
      this.visible = false
    },
    $_onTriggerMouseenter() {
      if (this.trigger !== 'hover' || this.confirm) {
        return false
      }
      this.visible = true
    },
    $_onTriggerMouseleave() {
      if (this.trigger !== 'hover' || this.confirm) {
        return false
      }
      this.visible = false
    },
    $_getInputChildren() {
      const $input = this.$refs.reference.querySelectorAll('input')
      const $textarea = this.$refs.reference.querySelectorAll('textarea')
      let $children = null

      if ($input.length) {
        $children = $input[0]
      } else if ($textarea.length) {
        $children = $textarea[0]
      }

      return $children
    },
    $_stopClick() {
      return false
    },
    onFocus(fromInput = true) {
      if (
        this.trigger !== 'focus' ||
        this.confirm ||
        (this.isInput && !fromInput)
      ) {
        return false
      }
      this.visible = true
    },
    onBlur(fromInput = true) {
      if (
        this.trigger !== 'focus' ||
        this.confirm ||
        (this.isInput && !fromInput)
      ) {
        return false
      }
      this.visible = false
    },
    cancel() {
      this.visible = false
      this.$emit('on-cancel')
    },
    ok() {
      this.visible = false
      this.$emit('on-ok')
    }
  }
}
</script>



// WEBPACK FOOTER //
// poptip.vue?1c9bbf2c